function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === 'function') {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import styled from "styled-components";
import { Box } from "sprout-ui-primitives";
import { LandingPage, LandingH1, LandingSectionMaxWidth, LandingSection, LandingMaxWidth } from "sprout-ui-dom/dist/Landing";
import Head from "@sprout/client-layout/dist/Head";
import { features } from "@sprout/client-routes";
import { media } from "sprout-ui-theme";
import FeaturesPageFeature from "./FeaturesPageFeature";
const FeaturesPageFeatures = styled(Box)`
  display: grid;
  gap: 32px 16px;

  width: min(100%, 336px);
  margin-left: auto;
  margin-right: auto;

  ${media.up("medium")} {
    width: min(100%, 688px);
    grid-template-columns: repeat(4, 1fr);

    > * {
      grid-column: span 2;

      :last-child:nth-child(2n - 1) {
        grid-column-end: -2;
      }
    }
  }

  /* https://css-irl.info/controlling-leftover-grid-items/ */
  ${media.up("large")} {
    width: 100%;
    grid-template-columns: repeat(6, 1fr);
    > * {
      grid-column: span 2;

      :last-child:nth-child(3n - 1) {
        grid-column-end: -2;
      }

      :nth-last-child(2):nth-child(3n + 1) {
        grid-column-end: 4;
      }

      :last-child:nth-child(3n - 2) {
        grid-column-end: 5;
      }
    }
  }
`;
const FeaturesPage = ()=>{
    return /*#__PURE__*/ _jsxs(_Fragment, {
        children: [
            /*#__PURE__*/ _jsx(Head, {
                title: "Features | Sprout"
            }),
            /*#__PURE__*/ _jsxs(LandingPage, {
                children: [
                    /*#__PURE__*/ _jsx(LandingSectionMaxWidth, {
                        mb: "64px",
                        children: /*#__PURE__*/ _jsx(LandingH1, {
                            children: "Your workflows go better together"
                        })
                    }),
                    /*#__PURE__*/ _jsx(LandingSection, {
                        mt: 11,
                        px: [
                            7,
                            7,
                            7,
                            "160px"
                        ],
                        children: /*#__PURE__*/ _jsx(LandingMaxWidth, {
                            maxWidth: "1400px",
                            children: /*#__PURE__*/ _jsx(FeaturesPageFeatures, {
                                children: features.map((feature)=>/*#__PURE__*/ _jsx(FeaturesPageFeature, _objectSpread({}, feature), feature.title))
                            })
                        })
                    })
                ]
            })
        ]
    });
};
export default FeaturesPage;
